export default "/images/8360803e6eae27c8599cfd78c654043f.avif";